export default {
  init() {
    // JavaScript to be fired on the home page

    // jQuery('.navigation-pane').addClass('dark');
    // jQuery('.navigation-vertical-bar').addClass('dark');
    // jQuery('.navigation-horizontal-bar').addClass('dark');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js